/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import divorceAgreementSectionStyle from "./divorceAgreementSectionStyle";
import ExpandablePaper from "../../../ExpandablePaper/ExpandablePaper";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { toRegisterLink } from "../../../../services/redirect";
import Typography from "@mui/material/Typography";

const DivorceAgreementSection = () => {
  return (
    <Container sx={divorceAgreementSectionStyle.container}>
      <Typography variant={"h2"} sx={divorceAgreementSectionStyle.header}>
        Basis für eine einvernehmliche Scheidung:
        <br />
        Die Scheidungsfolgen&#8203;vereinbarung
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ExpandablePaper header={"Was sind Scheidungsfolgen?"}>
            <Typography sx={divorceAgreementSectionStyle.text}>
              Wenn die Ehepartner ein Jahr getrennt leben und beide die Scheidung wollen, ist eine einvernehmliche Scheidung möglich. Zudem müssen sich die
              Ehepartner im Vorfeld über alle Scheidungsfolgen einigen. Dies sind insbesondere der Ehegattenunterhalt und die Verteilung von Besitz, Wohnung und
              Hausrat. Bei gemeinsamen, minderjährigen Kindern müssen zusätzlich das Sorgerecht, Umgangsrecht und der Kindesunterhalt geregelt werden.
            </Typography>
          </ExpandablePaper>
        </Grid>
        <Grid item xs={12} md={6}>
          <ExpandablePaper header={"Scheidungsfolgen-Vereinbarung"}>
            <Typography sx={divorceAgreementSectionStyle.text}>
              Durch eine Scheidungsfolgenvereinbarung legen die Ehepartner Regeln fest, die nach dem Scheidungsverfahren und nach der rechtskräftigen Scheidung
              gelten sollen. Dies ermöglicht eine reibungslose und offene Klärung der verschiedenen Themen und verhindert, dass es zu einer sehr teuren,
              streitigen Scheidung vor Gericht kommt. Die Vereinbarung sollte notariell beurkundet werden, damit ein rechtskräftiges Dokument vorliegt.
            </Typography>
          </ExpandablePaper>
        </Grid>
      </Grid>
      <p>
        Sie möchten umfassende Informationen und eine kostenlose Vorlage für die Scheidungsfolgenvereinbarung erhalten? All das finden Sie im Ratgeber in der
        Servicewelt.
      </p>
      <Button
        sx={divorceAgreementSectionStyle.infoButton}
        color={"primary"}
        component={Link}
        to={toRegisterLink("/scheidung/registrierung", "/scheidung/wichtige-themen-ueberblick")}
      >
        Jetzt kostenlos registrieren
      </Button>
    </Container>
  );
};

export default DivorceAgreementSection;
